const phoneFormat = (value: string) => {
  let phoneNumber = value;

  // Remove non-digit characters
  phoneNumber = phoneNumber.replace(/\D/g, '');

  // Format the number as xxx-xxx-xxxx or x-xxx-xxx-xxxx
  if (phoneNumber.length > 3 && phoneNumber.length <= 6) {
    phoneNumber = phoneNumber.replace(/(\d{3})(\d{0,3})/, '$1-$2');
  } else if (phoneNumber.length > 6 && phoneNumber.length <= 10) {
    phoneNumber = phoneNumber.replace(/(\d{3})(\d{3})(\d{0,4})/, '$1-$2-$3');
  } else if (phoneNumber.length > 10) {
    phoneNumber = phoneNumber.replace(/(\d{1})(\d{3})(\d{3})(\d{0,4})/, '$1-$2-$3-$4');
  }

  return phoneNumber;
}

export default phoneFormat;
